export default "__VITE_ASSET__0fFbgpwA__"